export const allPermissions = [
    'menu.view',
    'menu.price.edit',
    'menu.item.create',
    'menu.item.edit',
    'menu.item.delete',
    'menu.image.manage',
    'specials.view',
    'specials.manage',
    'fuel.view',
    'fuel.manage',
    'users.view',
    'users.manage',
    'audit.view',
    'releases.view',
    'support.view',
    'config.manage'
];
export const rolePermissions = {
    manager: allPermissions,
    user: ['menu.view', 'menu.price.edit']
};
export function roleLabel(role) {
    return role === 'user' ? 'Staff' : 'Manager';
}
export function hasPermission(subject, permission) {
    if (typeof subject === 'string')
        return rolePermissions[subject].includes(permission);
    if (subject.role === 'manager')
        return true;
    return subject.permissions.includes(permission);
}
